/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LOCALE_ID, NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule
} from '@nebular/theme';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { ModalModule } from 'ngx-bootstrap/modal';
import { UpdateService } from './update.service';
import { ReactiveFormsModule } from '@angular/forms';
import { registerLocaleData } from '@angular/common';
import localeUY from '@angular/common/locales/es-UY';
import localeUYExtra from '@angular/common/locales/extra/es-UY';
import { MessagingService } from './@controllers/messagging-service';
import { PublicationStatusPipe } from './publication-status.pipe';
import { httpsInterceptor } from './http-interceptor';
import { ActiveUserService } from './@shared/active-user.service';
import { ActiveMeliAccount } from './@shared/active_meliaccount';
//import { AmazingTimePickerModule } from 'amazing-time-picker';

import { PersonasComponent } from './components/personas/personas.component';
import { UsuariosComponent } from './components/usuarios/usuarios.component';
import { AsistenciasComponent } from './components/asistencias/asistencias.component';
import { RubrosComponent } from './components/rubros/rubros.component';
import { EmpresasComponent } from './components/empresas/empresas.component';
import { EquiposComponent } from './components/equipos/equipos.component';
import { ContratosComponent } from './components/contratos/contratos.component';
import { FuncionariosComponent } from './components/funcionarios/funcionarios.component';
//import { ConstanciasComponent } from './components/constancias/constancias.component';
//import '@angular/common/locales/global/es-MX';

registerLocaleData(localeUY, 'es-UY', localeUYExtra);

@NgModule({
  declarations: [AppComponent, PublicationStatusPipe],
  exports: [ModalModule],
  providers: [
    UpdateService,
    ActiveUserService,
    ActiveMeliAccount,
    MessagingService,
    PublicationStatusPipe,
    [{ provide: HTTP_INTERCEPTORS, useClass: httpsInterceptor, multi: true },{ provide: LOCALE_ID, useValue: 'es-UY' }]
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    ThemeModule.forRoot(),
    ModalModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    ReactiveFormsModule,

    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY'
    }),
    CoreModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production
    })
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
